export default "__VITE_ASSET__7726f2f3__"